import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Request } from 'src/types'
import { resetSaveFullRequest } from 'src/core/store/ducks/requests/actions'
import { useStepsContext } from 'src/views/Requests/views/Form'
import RequestSummary from 'src/views/Requests/components/RequestSummary'
import StepsNavigation from 'src/views/Requests/views/Form/components/StepsNavigation'
import useReasonPolicyRule from 'src/core/hooks/use-reason-policy-rule'

interface Params {
  reason_id: string
}

function Summary({
  match: {
    params: { reason_id }
  }
}: RouteComponentProps<Params>) {
  const dispatch = useDispatch()
  const policyRule = useReasonPolicyRule(reason_id)
  const stepsContext = useStepsContext()

  useEffect(() => {
    return () => {
      stepsContext.clearAlerts()
      dispatch(resetSaveFullRequest())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  function saveRequest(request: Request) {
    stepsContext.setRequest(request)
  }

  return (
    <>
      <StepsNavigation />
      <RequestSummary
        enableAdvances={policyRule ? policyRule.enable_advance : true}
        enableBilling={policyRule ? policyRule.enable_standard_billing : true}
        enableBudget={policyRule ? policyRule.enable_budget : false}
        enableEditObservation
        enableItineraries={policyRule ? policyRule.enable_itinerary : true}
        enableSharing={policyRule ? policyRule.enable_standard_sharing : true}
        request={stepsContext.request}
        saveRequest={saveRequest}
      />
    </>
  )
}

export default withRouter(Summary)
